import React from "react";
import ReactDOM from "react-dom";
import InvestorCalendars from "./containers/InvestorCalendars";
import {isEmpty} from "lodash";

export const initInvestorCalendars = className => {
  let elements = document.querySelectorAll(`.${className}`);
  if (!isEmpty(elements)) {
    for (let element of elements) {
      ReactDOM.render(<InvestorCalendars />, element);
    }
  }
};
